/** The terms step's wording for the Privacy Policy v1.2 acceptance (C9, approved by RJ Legal, 25 Oct 2026, via Prabash;
 * ~/preekie-coord/proposals/v1.2-FINAL/C9-reacceptance-screen-text.md). Word for word: don't edit without the lawyer. Each
 * document is named with its own version; "Version 1.2" never stands alone above the Terms. */

export const REACCEPT_COPY = {
  heading: "We've updated our Privacy Policy",
  lead: "Please read what's changed, then continue. The Software Terms haven't changed.",
  whatsNew: "What's new in version 1.2",
  bullets: [
    "The person recording a meeting can pause it. Nothing is recorded while a recording is paused, and the notes show when pauses happened.",
    "The person who recorded a meeting, or an administrator of your account, can delete it. We then keep only a short record that it existed and the record that consent to record it was confirmed.",
    "A new section explains who at Preekie can see your information, and when.",
    "We've updated how we describe our audit trail and cookies, and how we tell you about changes.",
  ],
  readPrivacy: "Read the Privacy Policy (version 1.2)",
  readTerms: "Read the Software Terms (version 1.1)",
  // "By selecting **Accept and continue**, you confirm …": the button's name is bold on screen.
  confirmBefore: "By selecting ",
  confirmAfter: ", you confirm you've read the Privacy Policy (version 1.2) and you continue to accept the Software Terms (version 1.1).",
  accept: "Accept and continue",
  signOut: "Sign out",
} as const;

export const NEW_USER_COPY = {
  heading: "Accept the Software Terms",
  lead: "Read the terms below, then accept to continue. Accepting also confirms you've read our Privacy Policy.",
  versions: "Software Terms version 1.1 · Privacy Policy version 1.2",
  readPrivacy: "Read the Privacy Policy (version 1.2)",
  accept: "Accept and continue",
} as const;

/** What A's 403 terms_required says (contracts: kind, terms_version, privacy_version). */
export interface TermsRequired {
  kind?: unknown;
  terms_version?: unknown;
  privacy_version?: unknown;
}

/** Which screen: the approved v1.2 wording only for exactly Software Terms 1.1 + Privacy Policy 1.2 (the versions it names);
 * anything else (an older server, a later version) keeps today's screen. "update" only for someone who accepted before. */
export function termsVariant(body: TermsRequired): "update" | "new" | "legacy" {
  if (body.terms_version !== "1.1" || body.privacy_version !== "1.2") return "legacy";
  return body.kind === "update" ? "update" : "new";
}
